import { ComponentType } from 'react'

// This file will be populated as we migrate pages
// For now, we'll create placeholder components and add real ones as we migrate

/**
 * Route Registry
 * Maps database route paths to React components
 * This must include ALL possible routes that can come from the database
 */
// Import migrated pages
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import ContainerYardPage from '@/pages/ContainerYards'
import ContainerYardCreatePage from '@/pages/ContainerYards/Create'
import ContainerYardEditPage from '@/pages/ContainerYards/Edit'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import TwoFactor from '@/pages/TwoFactor'
import TwoFactorSetup from '@/pages/TwoFactor/Setup'
import Profile from '@/pages/Profile'
import CategoriesPage from '@/pages/ContentManagement/Categories'
import CategoriesCreatePage from '@/pages/ContentManagement/Categories/Create'
import CategoriesEditPage from '@/pages/ContentManagement/Categories/Edit'
import TagsPage from '@/pages/ContentManagement/Tags'
import TagsCreatePage from '@/pages/ContentManagement/Tags/Create'
import TagsEditPage from '@/pages/ContentManagement/Tags/Edit'
import PagesPage from '@/pages/ContentManagement/Pages'
import PagesCreatePage from '@/pages/ContentManagement/Pages/Create'
import PagesEditPage from '@/pages/ContentManagement/Pages/Edit'
import MediaLibraryPage from '@/pages/ContentManagement/MediaLibrary'
import UsersPage from '@/pages/UserManagement/Users'
import CreateUserPage from '@/pages/UserManagement/Users/Create'
import EditUserPage from '@/pages/UserManagement/Users/Edit'
import RolesPage from '@/pages/UserManagement/Roles'
import CreateRolePage from '@/pages/UserManagement/Roles/Create'
import EditRolePage from '@/pages/UserManagement/Roles/Edit'
import UserActivityPage from '@/pages/UserManagement/UserActivity'
import GeneralSettingsPage from '@/pages/SystemSettings/General'
import EmailSettingsPage from '@/pages/SystemSettings/EmailSettings'
import SecuritySettingsPage from '@/pages/SystemSettings/Security'
import NavigationSettingsPage from '@/pages/SystemSettings/Navigation'
import CreateNavigationPage from '@/pages/SystemSettings/Navigation/Create'
import EditNavigationPage from '@/pages/SystemSettings/Navigation/Edit'
import TranslationsPage from '@/pages/SystemSettings/Language'
import CreateTranslationPage from '@/pages/SystemSettings/Language/Create'
import EditTranslationPage from '@/pages/SystemSettings/Language/Edit'
import LanguagesPage from '@/pages/SystemSettings/Language/Languages'
import CreateLanguagePage from '@/pages/SystemSettings/Language/Languages/Create'
import EditLanguagePage from '@/pages/SystemSettings/Language/Languages/Edit'
import BackupRestorePage from '@/pages/SystemSettings/BackupRestore'
import CreateBackupPage from '@/pages/SystemSettings/BackupRestore/Create'
import CreateBackupLegacyPage from '@/pages/SystemSettings/BackupRestore/CreateBackup'
import SchedulesPage from '@/pages/SystemSettings/BackupRestore/Schedules'
import CreateSchedulePage from '@/pages/SystemSettings/BackupRestore/Schedules/Create'
import EditSchedulePage from '@/pages/SystemSettings/BackupRestore/Schedules/Edit'
import AnalyticsDashboardPage from '@/pages/Analytics/AnalyticsDashboard'
import ActivityLogsPage from '@/pages/Analytics/ActivityLogs'
import UserReportsPage from '@/pages/Analytics/UserReports'
import ContentReportsPage from '@/pages/Analytics/ContentReports'
import ContentPage from '@/pages/Content'
import TestCSPPage from '@/pages/TestCSP'
import ShippingLinePage from '@/pages/ShippingLinesManagement'
import CreateShippingLinePage from '@/pages/ShippingLinesManagement/Create'
import EditShippingLinePage from '@/pages/ShippingLinesManagement/Edit'
import TrucksPage from '@/pages/FleetManagement/Trucks'
import CreateTruckPage from '@/pages/FleetManagement/Trucks/CreateTruckPage'
import EditTruckPage from '@/pages/FleetManagement/Trucks/EditTruckPage'
import MaintenanceHistoryPage from '@/pages/FleetManagement/MaintenanceHistory'
import FixedExpensesPage from '@/pages/RatesAndExpenses/FixedExpenses'
import CreateFixedExpensePage from '@/pages/RatesAndExpenses/FixedExpenses/Create'
import EditFixedExpensePage from '@/pages/RatesAndExpenses/FixedExpenses/Edit'
import AddMaintenancePage from '@/pages/FleetManagement/MaintenanceHistory/AddMaintenancePage'
import EditMaintenancePage from '@/pages/FleetManagement/MaintenanceHistory/EditMaintenancePage'
import DriversPage from '@/pages/FleetManagement/Drivers'
import AddDriverPage from '@/pages/FleetManagement/Drivers/Create'
import EditDriverPage from '@/pages/FleetManagement/Drivers/Edit'
import DriversWaybillHistoryPage from '@/pages/FleetManagement/DriversWaybillHistory'
import DriversCAHistoryPage from '@/pages/FleetManagement/DriversCAHistory'
import HelpersPage from '@/pages/FleetManagement/Helpers'
import AddHelperPage from '@/pages/FleetManagement/Helpers/Create'
import EditHelperPage from '@/pages/FleetManagement/Helpers/Edit'
import HelperCAHistoryPage from '@/pages/FleetManagement/HelperCAHistory'
import HelperWaybillHistoryPage from '@/pages/FleetManagement/HelperWaybillHistory'
import RatePerClientPage from '@/pages/RatesAndExpenses/RatePerClient'
import CreateRatePerClientPage from '@/pages/RatesAndExpenses/RatePerClient/Create'
import EditRatePerClientPage from '@/pages/RatesAndExpenses/RatePerClient/Edit'
import BudgetManagementPage from '@/pages/BudgetManagement'
import CreateBudgetManagementPage from '@/pages/BudgetManagement/Create'
import EditBudgetManagementPage from '@/pages/BudgetManagement/Edit'
import BookingManagementPage from '@/pages/BookingManagement/Bookings'
import BookingCreatePage from '@/pages/BookingManagement/Bookings/Create'
import BookingEditPage from '@/pages/BookingManagement/Bookings/Edit'
import WaybillsPage from '@/pages/BookingManagement/Waybills'
import WaybillCreatePage from '@/pages/BookingManagement/Waybills/Create'
import WaybillEditPage from '@/pages/BookingManagement/Waybills/Edit'
import DailyOperationsExpensesPage from '@/pages/Analytics/DailyOperationExpenses'
import TransportSummaryReportPage from '@/pages/Analytics/TransportSummaryReports'
import TruckSummaryPage from '@/pages/Analytics/TruckSummaryReport'
import DetailedExpensesPage from '@/pages/Analytics/DetailedExpenses'
import FinancialStatementsPage from '@/pages/ShippingLinesManagement/FinancialStatements'
import CreateSoaPage from '@/pages/ShippingLinesManagement/FinancialStatements/CreateSoa'
import EditSoaPage from '@/pages/ShippingLinesManagement/FinancialStatements/EditSoa'
import DownloadSoaPage from '@/pages/ShippingLinesManagement/FinancialStatements/DownloadSoa'
import EmailSoaToClientPage from '@/pages/ShippingLinesManagement/FinancialStatements/EmailSoaToClient'
import CreateInvoicePage from '@/pages/ShippingLinesManagement/FinancialStatements/CreateInvoice'
import EditInvoicePage from '@/pages/ShippingLinesManagement/FinancialStatements/EditInvoice'
import CreateBillingPage from '@/pages/ShippingLinesManagement/FinancialStatements/CreateBilling'
import EditBillingPage from '@/pages/ShippingLinesManagement/FinancialStatements/EditBilling'
import DownloadInvoicePage from '@/pages/ShippingLinesManagement/FinancialStatements/DownloadInvoice'
import EmailInvoiceToClientPage from '@/pages/ShippingLinesManagement/FinancialStatements/EmailInvoiceToClient'
import DownloadBillingPage from '@/pages/ShippingLinesManagement/FinancialStatements/DownloadBilling'
import DownloadBillingAndSoaPage from '@/pages/ShippingLinesManagement/FinancialStatements/DownloadBillingAndSoa'
import EmailBillingToClientPage from '@/pages/ShippingLinesManagement/FinancialStatements/EmailBillingToClient'
import EmailBillingAndSoaToClientPage from '@/pages/ShippingLinesManagement/FinancialStatements/EmailBillingAndSoaToClient'

export const routeRegistry: Record<string, ComponentType<any>> = {
  // Public routes
  '/login': Login,
  '/forgot-password': ForgotPassword,
  '/reset-password': ResetPassword,
  '/two-factor': TwoFactor,
  '/two-factor/setup': TwoFactorSetup,

  // Dashboard
  '/dashboard': Dashboard,

  // Booking Management
  '/bookings': BookingManagementPage,
  '/bookings/create': BookingCreatePage,
  '/bookings/:id': BookingEditPage,
  '/bookings/waybills/:bookingId': WaybillsPage,
  '/bookings/waybills/:bookingId/create': WaybillCreatePage,
  '/bookings/waybills/:bookingId/:id': WaybillEditPage,

  // Container Yard
  '/container-yards': ContainerYardPage,
  '/container-yards/create': ContainerYardCreatePage,
  '/container-yards/:id': ContainerYardEditPage,

  // Content Management
  '/content-management/categories': CategoriesPage,
  '/content-management/categories/create': CategoriesCreatePage,
  '/content-management/categories/:id': CategoriesEditPage,
  '/content-management/pages': PagesPage,
  '/content-management/pages/create': PagesCreatePage,
  '/content-management/pages/:id': PagesEditPage,
  '/content-management/tags': TagsPage,
  '/content-management/tags/create': TagsCreatePage,
  '/content-management/tags/:id': TagsEditPage,
  '/content-management/media-library': MediaLibraryPage,

  // User Management
  '/user-management/users': UsersPage,
  '/user-management/users/create': CreateUserPage,
  '/user-management/users/:id': EditUserPage,
  '/user-management/roles': RolesPage,
  '/user-management/roles/create': CreateRolePage,
  '/user-management/roles/:id': EditRolePage,
  '/user-management/user-activity/:userId': UserActivityPage,

  // System Settings
  '/system-settings/settings': GeneralSettingsPage,
  '/system-settings/security': SecuritySettingsPage,
  '/system-settings/email-settings': EmailSettingsPage,
  '/system-settings/navigation': NavigationSettingsPage,
  '/system-settings/navigation/create': CreateNavigationPage,
  '/system-settings/navigation/:id': EditNavigationPage,
  '/system-settings/language': TranslationsPage,
  '/system-settings/language/create': CreateTranslationPage,
  '/system-settings/language/:id': EditTranslationPage,
  '/system-settings/language/translations/:id': EditTranslationPage,
  '/system-settings/language/languages': LanguagesPage,
  '/system-settings/language/languages/create': CreateLanguagePage,
  '/system-settings/language/languages/:id': EditLanguagePage,
  '/system-settings/backup-restore': BackupRestorePage,
  '/system-settings/backup-restore/create': CreateBackupPage,
  '/system-settings/backup-restore/create-legacy': CreateBackupLegacyPage,
  '/system-settings/backup-restore/schedules': SchedulesPage,
  '/system-settings/backup-restore/schedules/create': CreateSchedulePage,
  '/system-settings/backup-restore/schedules/:id': EditSchedulePage,

  // Analytics
  '/analytics/analytics-dashboard': AnalyticsDashboardPage,
  '/analytics/activity-logs': ActivityLogsPage,
  '/analytics/user-reports': UserReportsPage,
  '/analytics/content-reports': ContentReportsPage,
  '/analytics/daily-operation-expenses': DailyOperationsExpensesPage,
  '/analytics/transport-summary-report': TransportSummaryReportPage,
  '/analytics/transport-summary/:plateId': TruckSummaryPage,
  '/analytics/detailed-expenses/:date': DetailedExpensesPage,

  // Fleet Management
  '/fleet-management/trucks': TrucksPage,
  '/fleet-management/trucks/create': CreateTruckPage,
  '/fleet-management/trucks/:id': EditTruckPage, 
  //'/fleet-management/maintenance-history/:id': MaintenanceHistoryPage,
  //'/fleet-management/maintenance-history/:id/edit': EditMaintenancePage,
  '/fleet-management/maintenance-history/:truckId/:id': EditMaintenancePage,
  '/fleet-management/maintenance-history/:id/create': AddMaintenancePage,
  '/fleet-management/maintenance-history/:truckId': MaintenanceHistoryPage,

  '/fleet-management/drivers': DriversPage,
  '/fleet-management/drivers/create': AddDriverPage,
  '/fleet-management/drivers/:id': EditDriverPage,
  '/fleet-management/waybill-history/:id': DriversWaybillHistoryPage,
  '/fleet-management/ca-history/:id': DriversCAHistoryPage,
  '/fleet-management/helpers': HelpersPage,
  '/fleet-management/helpers/create': AddHelperPage,
  '/fleet-management/helpers/:id': EditHelperPage,
  '/fleet-management/helpers-waybill-history/:id': HelperWaybillHistoryPage,
  '/fleet-management/helpers-ca-history/:id': HelperCAHistoryPage,

  // Other
  '/profile': Profile,
  '/content': ContentPage,
  '/test-csp': TestCSPPage,

  // Shipping Lines
  '/shipping-lines': ShippingLinePage,
  '/shipping-lines/create': CreateShippingLinePage,
  '/shipping-lines/:id': EditShippingLinePage,
  
  '/shipping-lines/financial-statements/:shippingLineId': FinancialStatementsPage,
  '/shipping-lines/financial-statements/:shippingLineId/soa/create': CreateSoaPage,
  '/shipping-lines/financial-statements/:shippingLineId/soa/:soaId': EditSoaPage,
  '/shipping-lines/financial-statements/:shippingLineId/soa/:soaId/download': DownloadSoaPage,
  '/shipping-lines/financial-statements/:shippingLineId/soa/:soaId/email': EmailSoaToClientPage,
  '/shipping-lines/financial-statements/:shippingLineId/invoice/create': CreateInvoicePage,
  '/shipping-lines/financial-statements/:shippingLineId/invoice/:invoiceId': EditInvoicePage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/create': CreateBillingPage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/:billingStatementId': EditBillingPage,
  '/shipping-lines/financial-statements/:shippingLineId/invoice/:invoiceId/download': DownloadInvoicePage,
  '/shipping-lines/financial-statements/:shippingLineId/invoice/:invoiceId/email': EmailInvoiceToClientPage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/:billingStatementId/download': DownloadBillingPage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/:billingStatementId/download-soa-and-billing': DownloadBillingAndSoaPage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/:billingStatementId/email': EmailBillingToClientPage,
  '/shipping-lines/financial-statements/:shippingLineId/billing/:billingStatementId/email-soa-and-billing': EmailBillingAndSoaToClientPage,

  // Rates and Expenses
  '/rates-and-expenses/fixed-expenses': FixedExpensesPage,
  '/rates-and-expenses/fixed-expenses/create': CreateFixedExpensePage,
  '/rates-and-expenses/fixed-expenses/:id': EditFixedExpensePage,

  '/rates-and-expenses/rate-per-client': RatePerClientPage,
  '/rates-and-expenses/rate-per-client/create': CreateRatePerClientPage,
  '/rates-and-expenses/rate-per-client/:id': EditRatePerClientPage,

  // Budget Management
  '/budget-management': BudgetManagementPage,
  '/budget-management/create': CreateBudgetManagementPage,
  '/budget-management/:expenseType/:id': EditBudgetManagementPage,


}

/**
 * Get component for a route path
 * Handles dynamic segments (e.g., :id, :userId)
 */
export function getRouteComponent(path: string): ComponentType<any> | null {
  // Direct match
  if (routeRegistry[path]) {
    return routeRegistry[path]
  }

  // Try to match dynamic routes
  // e.g., "/categories/123" matches "/categories/:id"
  const dynamicPatterns = Object.keys(routeRegistry).filter(key => key.includes(':'))
  
  for (const pattern of dynamicPatterns) {
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$')
    if (regex.test(path)) {
      return routeRegistry[pattern]
    }
  }

  return null
}

